import { searchConstants } from './constants';

const INITIAL_STATE = { 
    searchQry: '',
    isFetching: false,
    searchResults: [],
    showResults: false,
    student: {},
    courses: []
 };

 // Selector
function getCursesSelector(json) {
  let dev =  json.map( course => {
    return { value: course.course_id , label: course.name + " Turno " + course.shift_name }
  })

  return dev;
}

export function search(state = INITIAL_STATE, action) {
   switch (action.type) {

    case searchConstants.INITIATE_SEARCH:
      return {
          ...state,
          searchQry: action.searchQry,
          isFetching: action.isFetching,
          searchResults : action.searchResults,
         };  

    case searchConstants.LOAD_COURSES:
        return {
            ...state,
            // courses:  action.courses,
            courses: getCursesSelector(action.courses)
        }
      
         
    case searchConstants.RECEIVE_SEARCH_RESULTS:
        return {
            ...state,
            searchQry: action.searchQry,
            searchResults : action.searchResults,
            isFetching: action.isFetching, 
            showResults: true
           };  

    default:
      return state
  }
}

